import React from "react";
import Dropdown from "Components/DesignSystem/Dropdown/Dropdown";
import Pagination from "Components/DesignSystem/Pagination/Pagination";

/**
 * The footer strip under all three CS tables (both list tabs + the weightage editor's
 * version table). Was a native `<select>` + `Common/PaginatorWithApi`; now the DS
 * `Dropdown` + `Pagination` pair, laid out like Catalog Management's
 * `TablePaginationBar` / ISR's home strip (sm rung, right-aligned, one group).
 *
 * The props contract is unchanged on purpose — the three consumers and their
 * mount/unmount guards stay byte-identical.
 */
const PAGE_SIZE_OPTIONS = [
    { label: '10', value: 10 },
    { label: '20', value: 20 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
    { label: 'All', value: 10000 },
];

function CSTablePagination(props: {
    paginationParams: { page: number, per_page: number },
    updatePageSize: (size: number) => void,
    handlePageChange: (page: number) => void,
    totalRecords: number
},
) {

    return (
        <div className="tw-mb-4 tw-mt-2 tw-flex tw-items-center tw-justify-end tw-gap-3 tw-flex-wrap" data-testid="cs-table-pagination">
            <Dropdown
                id="components-cstablepagination-select-1"
                label=""
                aria-label="Rows per page"
                size="sm"
                options={PAGE_SIZE_OPTIONS}
                value={props?.paginationParams?.per_page}
                onChange={(value) => props?.updatePageSize(Number(value))}
                className="tw-w-[84px]"
                usePortal
                data-testid="components-cstablepagination-select-1"
            />
            <Pagination
                page={props?.paginationParams?.page}
                totalItems={props?.totalRecords ?? 0}
                pageSize={props?.paginationParams?.per_page}
                onPageChange={props?.handlePageChange}
                size="sm"
                className="tw-flex-none"
                data-testid="cs-table-pagination-pages"
            />
        </div>
    );
}

export default CSTablePagination
